import { render, staticRenderFns } from "./behaviors-detail.vue?vue&type=template&id=57932280&"
import script from "./behaviors-detail.vue.js?vue&type=script&lang=js&"
export * from "./behaviors-detail.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports